"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpacerWithChildren = exports.SpacerNoChildren = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var SpacerNoChildren = _styledComponents.default.div.withConfig({
  displayName: "Spacerstyle__SpacerNoChildren",
  componentId: "sc-18g3vvg-0"
})(["width:100%;height:", ";transition:", ";", ";"], function (_ref) {
  var theme = _ref.theme,
    size = _ref.size;
  return theme.space[size];
}, function (_ref2) {
  var animation = _ref2.theme.animation;
  return animation.transitionFast;
}, function (_ref3) {
  var theme = _ref3.theme,
    breakpoints = _ref3.breakpoints;
  if (Object.keys(breakpoints).length < 1) return false;
  return Object.keys(breakpoints).map(function (key) {
    return (0, _styledComponents.css)(["@media (min-width:", "){height:", ";}"], theme.breakpoints[key], theme.space[breakpoints[key]]);
  });
});
exports.SpacerNoChildren = SpacerNoChildren;
var SpacerWithChildren = _styledComponents.default.div.withConfig({
  displayName: "Spacerstyle__SpacerWithChildren",
  componentId: "sc-18g3vvg-1"
})(["transition:", ";", ";", ";", ";"], function (_ref4) {
  var animation = _ref4.theme.animation;
  return animation.transitionFast;
}, function (_ref5) {
  var top = _ref5.top,
    bottom = _ref5.bottom,
    left = _ref5.left,
    right = _ref5.right,
    size = _ref5.size,
    theme = _ref5.theme;

  // TODO: Add responsive breakpoints
  if (top || bottom || left || right) {
    return (0, _styledComponents.css)(["", " ", " ", " ", ""], top && "padding-top: ".concat(theme.space[size], ";"), (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          ", "\n        "])), right && "padding-right: ".concat(theme.space[size], ";")), bottom && "padding-bottom: ".concat(theme.space[size], ";"), (0, _styledComponentsRtl.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          ", "\n        "])), left && "padding-left: ".concat(theme.space[size], ";")));
  } else {
    return (0, _styledComponents.css)(["padding:", ";"], function (_ref6) {
      var theme = _ref6.theme,
        size = _ref6.size;
      return theme.space[size];
    });
  }
}, function (_ref7) {
  var noTop = _ref7.noTop,
    noBottom = _ref7.noBottom,
    noLeft = _ref7.noLeft,
    noRight = _ref7.noRight;
  return (0, _styledComponents.css)(["", " ", " ", " ", ""], noTop && "padding-top: 0;", (0, _styledComponentsRtl.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        ", "\n      "])), noRight && "padding-right: 0;"), noBottom && "padding-bottom: 0;", (0, _styledComponentsRtl.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        ", "\n      "])), noLeft && "padding-left: 0;"));
}, function (_ref8) {
  var theme = _ref8.theme,
    breakpoints = _ref8.breakpoints,
    noTop = _ref8.noTop,
    noBottom = _ref8.noBottom,
    noLeft = _ref8.noLeft,
    noRight = _ref8.noRight;
  var keys = Object.keys(breakpoints);
  if (keys.length < 1) return false;
  return keys.map(function (key) {
    var space = theme.space[breakpoints[key]];
    return (0, _styledComponents.css)(["@media (min-width:", "){padding-top:", ";", " padding-bottom:", ";", "}"], theme.breakpoints[key], noTop ? 0 : space, (0, _styledComponentsRtl.default)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            padding-right: ", ";\n          "])), noRight ? 0 : space), noBottom ? 0 : space, (0, _styledComponentsRtl.default)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            padding-left: ", ";\n          "])), noLeft ? 0 : space));
  });
});
exports.SpacerWithChildren = SpacerWithChildren;